import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { QRcodePrint } from './Pages';

export const QRcodePrintRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={QRcodePrint} />
       
    </Fragment>
)